export const locationURL = '/api/location';
export const getAreaURL = `/api/web-location/location/areas?countryId={0}&lat={1}&lng={2}`;
export const careSendMessageURL = '/v1/care/send-email';
export const getExternalPaymentsApiURL = '/api/external-payment-form-url/{0}';
export const getAddCardFormApiURL =
  '/api/payments/add-card-form-url?purchaseId={0}';
export const getSecurityCodeFormApiURL =
  '/api/payments/security-code-form?purchaseId={0}&instrumentId={1}';
export const claimBookBase = '/claim-book';

export const initWebPayOneClickTransactionURL =
  '/v1/payments/initInscriptionOneClick?origin=mweb';
export const initWebPayOneClickTransactionRegEx = /\/v1\/payments\/initInscriptionOneClick/;
